var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form_unit"},[_vm._v("基本信息")]),_c('label-text-properties',{attrs:{"canvas":_vm.canvas,"element":_vm.element}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }